enum EYarikanoQuestionId {
  GROUP = 'group',
  TWO_SHOT = 'two_shot',
  PHOTO = 'photo',
  GACHA = 'gacha',
  FRANCHISE = 'franchise',
}

enum EYarikanoChatLogKind {
  QUESTION = 'question',
  ANSWER_TEXT = 'answer_text',
  ANSWER_VIDEO = 'answer_video',
  ANSWER_CTA = 'answer_cta',
}

enum EYarikanoCtaPlacement {
  ANSWER = 'answer',
  FOOTER = 'footer',
}

type TYarikanoQuestionId = `${EYarikanoQuestionId}`;

type TYarikanoCtaPlacement = `${EYarikanoCtaPlacement}`;

type TYarikanoChatItem = {
  id: EYarikanoQuestionId;
  suggestText: string;
  answerTexts: string[];
  videoUrl?: string;
};

type TYarikanoChatLogEntry = {
  kind: EYarikanoChatLogKind;
  id: string;
  questionId: EYarikanoQuestionId;
  text?: string;
  videoUrl?: string;
  timetoken: string;
};

type TYarikanoChatSessionState = {
  consumedIds: EYarikanoQuestionId[];
  log: TYarikanoChatLogEntry[];
};

export {
  EYarikanoQuestionId,
  EYarikanoChatLogKind,
  EYarikanoCtaPlacement,
};

export type {
  TYarikanoQuestionId,
  TYarikanoCtaPlacement,
  TYarikanoChatItem,
  TYarikanoChatLogEntry,
  TYarikanoChatSessionState,
};
